{{drug}}
<ng-container *ngIf="!last">,</ng-container>
